// removed by extract-text-webpack-plugin
module.exports = {"textList":"src-components----footer-module---textList---lhx8a","info":"src-components----footer-module---info---2pV1S","footerOuter":"src-components----footer-module---footerOuter---2qF-h","footerContainer":"src-components----footer-module---footerContainer---31iQd","leftFooterContainer":"src-components----footer-module---leftFooterContainer---3Oqbu","rightFooterContainer":"src-components----footer-module---rightFooterContainer---AbzWG","listContainer":"src-components----footer-module---listContainer---JmJ7w","copyright":"src-components----footer-module---copyright---2T6D_"};


//////////////////
// WEBPACK FOOTER
// ./src/components/footer.module.css
// module id = 110
// module chunks = 114276838955818 162898551421021